// extracted by mini-css-extract-plugin
export default {"wrapper":"Actions_wrapper__+kRQV"};